// extracted by mini-css-extract-plugin
export var skipAnimation = "_10-0";